module.exports = __webpack_public_path__ + "media/images/countrysquared/ly-1233b420bfb002f2b5230f9b9c626abd.svg";